module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "disableOutsideClick": true,
      "padding": "2em 3em",
      "maxWidth": "800px"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt3 flex items-center",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticClass: "b f3"
  }, [_c('strong', [_vm._v("You have to connect a class.")])]), _vm._v(" "), _c('div', {
    staticClass: "i f7 mt2 pl-primary"
  }, [_vm._v("\n      How does this work?\n      "), _c('i', {
    staticClass: "fas fa-external-link-alt",
    staticStyle: {
      "font-size": "8px",
      "vertical-align": "top"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "center mv4"
  }, [_c('p', {
    staticClass: "tc pl2 txt-modal-upgrade"
  }, [_vm._v("\n      You must connect this Parlay Course to a corresponding Course in\n      " + _vm._s(_vm.selected_integration) + " before you can create an assignment in\n      " + _vm._s(_vm.selected_integration) + ".\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "integrations-container w-70"
  }, [_c('div', {
    staticClass: "row col-xs no-margin middle-xs between-xs"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "height": "3.5em",
      "width": "3.5em"
    },
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "integration-classroom-title ml3"
  }, [_vm._v("\n          " + _vm._s(_vm.selected_integration) + "\n        ")])]), _vm._v(" "), _c('pl-button', {
    staticClass: "db b truncate-text",
    staticStyle: {
      "margin": "0",
      "border-right": "1px solid rgba(0, 0, 0, 0.2)",
      "border-bottom": "1px solid rgba(0, 0, 0, 0.2)",
      "min-width": "150px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.connectOrUpdateIntegration.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Connect Class\n      ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-329a25ae!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/integrationsConnectModal.vue
// module id = 988
// module chunks = 61